import React from 'react';
import { capitalize } from 'lodash';
import { Article } from '../../../../../../types/items';
import useStyles from './styles';
import useCommentStyles from '../../styles';
import { closedCaptions, durationOptions, firstEditOptions } from '../../../../modals/VideoEditStepModal/constants';
import ViewDetailsButton from '../../components/ViewDetailsButton';
import { getDurationKeyFromDuration } from '../../../../../../utility/orders';
import ActivityBaseComment from '../../ActivityBaseComment';

type Props = {
  article: Article;
};

const ActivityOrderComment = ({ article }: Props) => {
  const commentClasses = useCommentStyles();
  const classes = useStyles();
  const { order } = article.ref;
  const options = order?.options || {};
  const firstEditKey = order?.first_edit_delivery_id;
  const name = article.ref.project.user?.full_name_first_last;
  const {
    format: formats,
    closed_captions: captionKey,
    video_duration: durationKey,
    total_price: totalPrice,
  } = options;

  const durationInMin = parseInt(durationKey, 10) === 3 ? 5 : durationKey;
  const durationByOption = durationOptions
    .find((min) => min.id === getDurationKeyFromDuration(parseInt(durationInMin, 10)));
  const durationTitle = durationByOption
    ? durationByOption.title
    : `${durationInMin > 5 ? durationInMin : '-'} minutes`;

  const output = formats ? Object.entries(formats).reduce((str, format) => {
    if (format[1]) {
      return str ? `${str},  ${capitalize(format[0])}` : capitalize(format[0]);
    }
    return str;
  }, '') : '';

  const caption = closedCaptions.find((cap) => cap.id === captionKey);
  const firstEdit = firstEditOptions.find((opt) => opt.id === firstEditKey);
  const firstEditInfo = firstEditKey === 'overnight'
    ? `${firstEdit?.label} next date at 9PM-PST/PDT`
    : `${firstEdit?.label} this date at 6PM-PST/PDT`;

  if (article.ref.order) {
    return (
      <ActivityBaseComment
        header={(
          <>
            <span className={commentClasses.accent}>{name}</span>
            {' '}
            has created an order for a new video edit. This project is
            {' '}
            <span className={commentClasses.accent}>Ready to Edit.</span>
            <span className={commentClasses.timestamp}>{article.ref.created_age}</span>
          </>
        )}
        content={(
          <div className={classes.order}>
            <div className={classes.orderTitle}>
              Video Edit Order
            </div>
            <div className={classes.orderContent}>
              <div>
                Title: {article.ref.order.title}
              </div>
              <div>
                Script: {article.ref.order.options.scene_title}
              </div>
              <div>
                Output: {output}
              </div>
              <div>
                Close Caption: {caption?.label}
              </div>
              <div>
                Duration: {durationTitle}
              </div>
              <div>
                First Edit: {firstEdit ? firstEditInfo : '-'}
              </div>
            </div>
            <hr className={commentClasses.lineBreak} />
            <div className={classes.footer}>
              <div className={classes.orderPrice}>
                {order && order.status_id === 'cancelled'
                  ? <span className={commentClasses.alertMessage}>Order Canceled</span>
                  : `Total Estimated Fees: $${totalPrice || '0'}`}
              </div>
              <ViewDetailsButton />
            </div>
          </div>
        )}
      />
    );
  }

  return null;
};

export default ActivityOrderComment;
